<!--
 * @Author: v_hllhe
 * @Date: 2022-12-19 13:24:48
 * @LastEditors: v_aydwang
 * @LastEditTime: 2023-01-10 17:02:57
 * @Description:
-->
<template>
  <div class="wrap">
    <div class="circleWrap">
      <circleGif class="circleGif" :warning="scoreInfo.avg_score<60"> </circleGif>
      <div class="circleContent">
        <div class="score-box">
          <div :class="{ score: true, moneyWarn: scoreInfo.avg_score<60 ? true : false }">
            <countTo :val="scoreInfo.avg_score"/>
          </div>
          <div>分</div>
        </div>
        <div class="title">
          <a-tooltip placement="top"  overlayClassName="achievementsTip">
              <div style="display:inline-block">绩效</div>
              <template slot="title">
                <span
                  v-html="tipconfig.achievementsTip"
                ></span>
              </template>
              <div class="tips"></div>
          </a-tooltip>
        </div>
      </div>
    </div>
    <polygonGif
      class="qualityScore"
      :content="{
        title: '质量评分',
        rate: 40,
        score: scoreInfo.zl_score,
        monthRate: scoreInfo.qualityMonth,
        warn: scoreInfo.zl_score<60 ? true:false
      }"
    ></polygonGif>
    <polygonGif
      class="effectScore"
      :content="{
        title: '有效时长评分',
        rate: 15,
        score: scoreInfo.hs_score,
        monthRate: scoreInfo.effectMonth,
        warn: scoreInfo.hs_score<60?true:false
      }"
    ></polygonGif>
    <polygonGif
      class="efficiencyScore"
      :content="{
        title: '效率评分',
        rate: 30,
        score: scoreInfo.xl_score,
        monthRate: scoreInfo.effectiveMonth,
        warn: scoreInfo.xl_score<60?true:false
      }"
    ></polygonGif>
    <polygonGif
      class="productScore"
      :content="{
        title: '产量评分',
        rate: 15,
        score: scoreInfo.cl_score,
        monthRate: scoreInfo.productMonth,
        warn: scoreInfo.cl_score<60?true:false
      }"
    ></polygonGif>
    <div class="light"></div>
    <water-spread class="waterSpread"> </water-spread>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import polygonGif from './polygonGif';
import circleGif from '@/components/circleGif';
import waterSpread from './waterSpread';
import countTo from '@/components/numGif';
import { tipconfig } from '../modules/const.js';

export default {
  name: '',
  // import引入的组件需要注入到对象中才能使用
  components: {
    polygonGif,
    circleGif,
    waterSpread,
    countTo,
  },
  props: {
    scoreInfo: {
      type: Object,
      default: () => ({
        avg_score: 0, // 绩效评分
        qualityRate: '40%', // 质量评分-权重
        zl_score: 0, // 质量评分-评分
        qualityMonth: '+10%', // 质量评分 - 月环比
        effectRate: '15%', // 有效时长评分-权重
        hs_score: 0, // 有效时长评分-评分
        effectMonth: '+10%', // 有效时长评分 - 月环比
        effectiveRate: '30%', // 效率评分-权重
        xl_score: 0, // 效率评分-评分
        effectiveMonth: '+10%', // 效率评分 - 月环比
        productRate: '15%', // 产量评分-权重
        cl_score: 0, // 产量评分-评分
        productMonth: '+10%', // 产量评分 - 月环比
      }),
    },
  },
  data() {
    // 这里存放数据
    return {
      tipconfig,
    };
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    changeTipStyle() {
      const len = document.getElementsByClassName('ant-tooltip');
      Object.values(len).map((item) => {
        item.style.minWidth = this.setSize(800);
        item.style.maxHeight = this.setHeight(450);
      });
    },
    setSize(x) {
      const vwx = `${(x / 1920) * 100}vw`;
      return vwx;
    },
    setHeight(x) {
      const vwx = `${(x / 1080) * 100}vh`;
      return vwx;
    },
  },
  beforeCreate() {}, // 生命周期 - 创建之前
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.timer = setInterval(() => {
      this.changeTipStyle();
    }, 1);
  },
  beforeMount() {}, // 生命周期 - 挂载之前
  beforeUpdate() {}, // 生命周期 - 更新之前
  updated() {}, // 生命周期 - 更新之后
  beforeDestroy() { // 生命周期 - 销毁之前
    clearInterval(this.timer);
  },
  destroyed() {}, // 生命周期 - 销毁完成
  activated() {}, // 如果页面有keep-alive缓存功能，这个函数会触发
  beforeRouteLeave() {
    // 路由离开钩子
  },
};
</script>
<style lang="scss" scoped>
@import "@/styles/convert-viewport";
.wrap {
  // background:yellow;
  position: relative;
  height: vh(479);
  width: vw(695);
}
.circleGif {
  position: absolute;
  top: vh(95);
  left: 50%;
  margin-left: vw(-110);
  width: vw(220);
  height: vw(220);
}
.circleContent {
  // background: pink;
  position: absolute;
  left: vw(239);
  top: vh(95);
  width: vw(220);
  height: vw(220);
  padding-top: vw(70);
  .score-box {
    display: flex;
    justify-content: center;
    align-items:flex-end;
    .score {
      font-family: TCloudNumber-Regular;
      font-weight: 400;
      font-size: vw(56);
      color: #165bec;
      letter-spacing: 0;
      line-height: vh(48);
      text-align: center;
    }
    .moneyWarn {
      color: #ec4f4f;
    }
  }
  .title {
    font-family: TencentSansW7;
    font-size: vw(24);
    color: #41557b;
    letter-spacing: 0;
    line-height: vh(32);
    display: flex;
    justify-content: center;
    margin-top: vh(10);
    cursor: pointer;
  }
  .tips {
    width: vw(18);
    height: vw(18);
    background: url("~@/assets/tips.png");
    background-size: 100% 100%;
    margin-top: vh(10);
    display: inline-block;
  }
}
.light {
  position: absolute;
  background: url("~@/assets/light.png");
  background-size: 100% 100%;
  width: vw(267.38);
  height: vh(439.81);
  left: 50%;
  top: vh(185);
  transform: translateX(-50%);
  z-index: -1;
}
.qualityScore {
  position: absolute;
  top: vw(-3);
  left: vw(-4);
}
.effectScore {
  position: absolute;
  top: vh(218);
  left: vw(-26);
}
.efficiencyScore {
  position: absolute;
  top: vw(-3);
  right: vw(-12);
}
.productScore {
  position: absolute;
  top: vh(218);
  right: vw(-30);
}
.waterSpread {
  position: absolute;
  top: vh(305);
  left: vw(255);
}
// TODO
.effectScore,.efficiencyScore { // 时长 效率
  animation: myfirst1 3.5s infinite ease-in-out;
}
@keyframes myfirst1 {
  0% {
    transform: translate(0px, -5px);
  }
  50% {
    transform: translate(0px, 5px);
  }
  100% {
    transform: translate(0px, -5px);
  }
}
.qualityScore,.productScore { // 质量 产量
  animation: myfirst4 3s infinite ease-in-out;
}
@keyframes myfirst4 {
  0% {
    transform: translate(0px, -5px);
  }
  50% {
    transform: translate(0px, 5px);
  }
  100% {
    transform: translate(0px, -5px);
  }
}
.circleWrap { // 绩效
  animation: myfirst2 4s infinite ease-in-out;

}
@keyframes myfirst2 {
  0% {
    transform: translate(0px, -20px);
  }
  50% {
    transform: translate(0px, 10px);
  }
  100% {
    transform: translate(0px, -20px);
  }
}
</style>
<style >
.achievementsTip{
  overflow-y: auto;
  min-width: 800px;
  max-height: 400px;
  border-radius: 8px;
}
.achievementsTip::-webkit-scrollbar {
  display: none;
}
.achievementsTip>.ant-tooltip-content>.ant-tooltip-inner{
    background:rgba(255, 255, 255, 0.8) !important;
    color:#56688A;
    padding: 20px 10px 10px 20px;
}
.achievementsTip>.ant-tooltip-content>.ant-tooltip-arrow::before{
    background:rgba(255, 255, 255, 0.8) !important;
}

</style>
